import { Box } from "@material-ui/core";

import { Listing } from "containers/Responsive/Listing";
import { INTERNATIONAL_SOURCE_DISPLAY_NAME } from "services/valuation/constants";
import { Source } from "services/valuation/types";
import theme from "theme";
import { REGULAR_CHART_COLOR_LIST } from "theme/constants";

import { SourceBreakdownChart } from "./SourceBreakdownChart";
import { SourceBreakdownTable } from "./SourceBreakdownTable";

export interface SourceBreakDownData {
  data: Source[];
  totalValue: number;
  colorList?: string[];
  title: string;
  pieChartHeight?: number;
}

export type SourceBreakdownChartAndTableProps = SourceBreakDownData & {
  colors: string[];
};

export function SourceBreakdown(props: SourceBreakDownData) {
  const COLORS = props.colorList || REGULAR_CHART_COLOR_LIST;

  const colors: string[] = [];
  props.data.forEach((s, i) => {
    if (!!s.earning_details && s.name === INTERNATIONAL_SOURCE_DISPLAY_NAME) {
      colors[i] = theme.custom.palette.green.main;
    } else {
      colors[i] = COLORS[i];
    }
  });

  return (
    <>
      <h2>{props.title}</h2>
      <Listing inverted>
        <Box display="flex" alignItems="center">
          <SourceBreakdownTable {...props} colors={colors} />
          <SourceBreakdownChart {...props} colors={colors} />
        </Box>
      </Listing>
    </>
  );
}
